angular.module('iqxCore')
.controller('AppLandingCtrl', function ($scope, $location, ApplicationSvc, $cookies) {
  ApplicationSvc.postLoginRoute = '/applanding'
  $cookies.putObject('appMode',true)
  ApplicationSvc.appMode=true

  $scope.navigate=function(u){
    $location.path(u)
  }
})
